export default "__VITE_ASSET__teoN2z9W__"